<!-- <template>
    
    <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
                v-model="snackbar">
                {{ text1 }}
                <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
            </v-snackbar>

           
  </template>

  
  <script>
  import auth from "../../../api/auth";
  import axios from "axios";
  
  export default {
  
   
    beforeMount: beforeMount,
    methods: {
      SatinAl() {

this.loadingdialog=true;
if (this.sozlesmeOnay == true) {
       
   

    this.UrunKayit.Tarih = getDateNow()
    this.UrunKayit.OdemeOnay = true
    this.UrunKayit.Aciklama = 'Stripe'

    var manageload = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));

    var index = manageload.AnaSirketInfo.findIndex(p => p.MusteriID == this.musteriidurun)

    this.UrunKayit.UlkeID = manageload.AnaSirketInfo[index].UlkeID

    var params = this.UrunKayit

    this.$http.post(auth.API_URL + 'api/Register/PackageCustomerPaymentSave', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

        if (response.body.Status == true) {

            if (response.body.SaveID != null && response.body.SaveID != '') {

                this.MusteriUrun.MusteriID = this.musteriidurun
               
                this.MusteriUrun.OdemeBilgi.ID = response.body.SaveID
                this.MusteriUrun.OdemeBilgi.OdemeTip = this.UrunKayit.OdemeTip
                this.MusteriUrun.OdemeBilgi.OdemeOnay = true
                this.MusteriUrun.OdemeBilgi.UlkeID = this.UrunKayit.UlkeID

                if (this.pakettipi == 2) {
                    this.MusteriUrun.KontorAdet = this.kontorAdet
                    this.MusteriUrun.KalanKontorAdet = this.kontorAdet
                    this.MusteriUrun.BaslangicTarih = getDateNow()
                    this.MusteriUrun.BitisTarihi = getDateNow()
                } else {
                    this.MusteriUrun.KontorAdet = 0
                    this.MusteriUrun.KalanKontorAdet = 0
                    this.MusteriUrun.BaslangicTarih = null
                    this.MusteriUrun.BitisTarihi = null
                }
                var params = this.MusteriUrun


                this.$http.post(auth.API_URL + 'api/Register/PackageCustomerSave',
                    params, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {

                     this.text1 = this.$t(response.body.ResponseMessage)
                     this.snackbar = true

                    if (response.body.Status == true) {
                        localStorage.removeItem('po');
                        setTimeout(function () {
                            var url = '#/anasirket'
                            window.open(url, '_self')
                        }.bind(this), 4000)
                    }


                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-PackageCustomerSave'
                        this.snackbar = true
                        this.loadingdialog=false;
                    } else {
                        this.text1 = 'Service Unavailable-PackageCustomerSave'
                        this.snackbar = true
                        this.loadingdialog=false;
                    }
                })


            } else {
                this.text1 =
                    'Payment registration has been completed. The product could not be introduced to your user. Please contact the support team.'
                this.snackbar = true
                this.loadingdialog=false;
            }

        } else {
             this.text1 = this.$t(response.body.ResponseMessage)
             this.snackbar = true
              this.loadingdialog=false;
        }


    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-ProductCustomerSave'
            this.snackbar = true
            this.loadingdialog=false;
        } else {
            this.text1 = 'Service Unavailable-ProductCustomerSave'
            this.snackbar = true
            this.loadingdialog=false;
        }
    })
} else {
    this.text1 = this.$t('You-need-approve-contract')
    this.snackbar = true
    this.loadingdialog=false;
}
},
    },
    data() {
      return {
        loadingdialog:false,
        snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
            text1:'',
        musteriidurun:0,
        sozlesmeOnay:true,
        kontorAdet:0,
       MusteriUrun: {
                ID: null,
                MusteriID: null,
                PaketBilgi: {
                    PaketID: null,
                    PaketTip: null,
                },
                OdemeBilgi: {
                    ID: null,
                    OdemeTip: 0,
                    OdemeOnay: false
                },
                BaslangicTarih: null,
                BitisTarihi: null,
                KontorAdet: 0,
                KalanKontorAdet: 0,
                BiletAdet: 0,
                FaturaAdet: 0,
                CariAdet: 0,
                IadeAdet: 0,
                VoidAdet: 0,
                CoperAdet: 0,
                CoperIptalAdet: 0,
                VizeAdet: 0,
            },
            UrunKayit: {
                ID: null,
                Aciklama: null,
                OdemeTip: '1', // 0 Havale 1 Kredi
                OdemeOnay: true,
                Tarih: null,
                Tutar: 0,
                Banka: null,
                TaksitAdet: null,
                VadeFarki: null,
                VadeTarihi: null,
                CariKod: null,
                FaturaTarihi: null,
                FaturaSeri: null,
                FaturaNo: null,
                IslemID: null,
                GuID: null,
                SiparisID: null,
                DekontID: null,
                UlkeID: null,
            },
      };
    },
  };
  function getDateNow() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd
        }

        if (mm < 10) {
            mm = '0' + mm
        }
        today = yyyy + '-' + mm + '-' + dd
        return today
    }
  function beforeMount() {
    
    var paket = JSON.parse(window.localStorage.getItem('po'));
    this.musteriidurun=paket.musteriid;
    this.UrunKayit.Tutar=paket.Tutar;
    this.MusteriUrun.MusteriID=paket.musteriid;
    this.MusteriUrun.PaketBilgi.PaketID=paket.paketid;
    this.MusteriUrun.PaketBilgi.PaketTip=paket.pakettip;
    this.kontorAdet=paket.kontorAdet;
    this.SatinAl();

    // var url = '#/account/urunler/id?sirket=null'
    // window.open(url, '_self')

    

  }
 
  </script> -->

<template>
  <div>
    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      :top="y === 'top'"
      :bottom="y === 'bottom'"
      :right="x === 'right'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :vertical="mode === 'vertical'"
    >
      {{ text1 }}
      <v-btn flat color="pink" @click="snackbar = false">
        {{ $t('Close') }}
      </v-btn>
    </v-snackbar>

    <!-- Progress Dialog (işlem sürerken açılır) -->
    <v-dialog v-model="loadingdialog" persistent width="340">
      <v-card class="pa-5">
        <div class="d-flex align-center justify-center mb-3">
          <v-progress-circular indeterminate :size="40" />
        </div>
        <div class="text-center subtitle-2">
          {{ loadingMessage || ($t('Processing') + '…') }}
        </div>
      </v-card>
    </v-dialog>

    <!-- İsteğe bağlı manuel tetikleme (otomatik akış varsa kapalı kalsın)
    <v-btn :loading="loadingdialog" color="primary" @click="SatinAl">
      {{ $t('Buy') }}
    </v-btn>
    -->
  </div>
</template>

<script>
import auth from "../../../api/auth";
import axios from "axios";

export default {
  data() {
    return {
      // UI
      loadingdialog: false,
      loadingMessage: "",
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      text1: "",

      // İş mantığı
      musteriidurun: 0,
      sozlesmeOnay: true,
      kontorAdet: 0,

      MusteriUrun: {
        ID: null,
        MusteriID: null,
        PaketBilgi: {
          PaketID: null,
          PaketTip: null,
        },
        OdemeBilgi: {
          ID: null,
          OdemeTip: 0,
          OdemeOnay: false,
          UlkeID: null,
        },
        BaslangicTarih: null,
        BitisTarihi: null,
        KontorAdet: 0,
        KalanKontorAdet: 0,
        BiletAdet: 0,
        FaturaAdet: 0,
        CariAdet: 0,
        IadeAdet: 0,
        VoidAdet: 0,
        CoperAdet: 0,
        CoperIptalAdet: 0,
        VizeAdet: 0,
      },

      UrunKayit: {
        ID: null,
        Aciklama: null,
        OdemeTip: "1", // 0 Havale, 1 Kredi
        OdemeOnay: true,
        Tarih: null,
        Tutar: 0,
        Banka: null,
        TaksitAdet: null,
        VadeFarki: null,
        VadeTarihi: null,
        CariKod: null,
        FaturaTarihi: null,
        FaturaSeri: null,
        FaturaNo: null,
        IslemID: null,
        GuID: null,
        SiparisID: null,
        DekontID: null,
        UlkeID: null,
      },
    };
  },

  async beforeMount() {
    // localStorage 'po' varsa otomatik satın al
    const paket = safeGetPo();
    if (paket) {
      this.musteriidurun = paket.musteriid ? paket.musteriid : 0;
      this.UrunKayit.Tutar = paket.Tutar ? Number(paket.Tutar) : 0;
      this.MusteriUrun.MusteriID = paket.musteriid ? paket.musteriid : null;
      this.MusteriUrun.PaketBilgi.PaketID = paket.paketid ? paket.paketid : null;
      this.MusteriUrun.PaketBilgi.PaketTip = paket.pakettip ? paket.pakettip : null;
      this.kontorAdet = paket.kontorAdet ? Number(paket.kontorAdet) : 0;
      await this.SatinAl();
    }
  },

  methods: {
    async SatinAl() {
      if (!this.sozlesmeOnay) {
        this.text1 = this.$t("You-need-approve-contract");
        this.snackbar = true;
        return;
      }

      this.loadingMessage = this.$t("Processing") + "…";
      this.loadingdialog = true;

      try {
        // Şirket bilgisi
        const manageloadRaw = window.localStorage.getItem("WebUserManageLoad");
        const manageload = manageloadRaw ? JSON.parse(manageloadRaw) : null;

        if (!manageload || !manageload.AnaSirketInfo || !Array.isArray(manageload.AnaSirketInfo)) {
          throw new Error("ManageLoad not found or invalid.");
        }

        const idx = manageload.AnaSirketInfo.findIndex(
          (p) => p && p.MusteriID == this.musteriidurun
        );
        if (idx === -1) {
          throw new Error("Company info not found for current customer.");
        }

        // Ürün kayıt verileri
        this.UrunKayit.Tarih = getDateNow();
        this.UrunKayit.OdemeOnay = true;
        this.UrunKayit.Aciklama = "Stripe";
        this.UrunKayit.UlkeID = manageload.AnaSirketInfo[idx].UlkeID;

        const headers = { Authorization: "Bearer " + auth.getAuthHeader() };

        // 1) Ödeme kaydı
        this.loadingMessage = this.$t("Saving payment") + "…";
        const savePaymentUrl = auth.API_URL + "api/Register/PackageCustomerPaymentSave";

        const paymentResp = await axios.post(savePaymentUrl, this.UrunKayit, { headers });
        const pay = paymentResp && paymentResp.data ? paymentResp.data : null;

        if (!pay || pay.Status !== true) {
          const msgKey = pay && pay.ResponseMessage ? pay.ResponseMessage : "Payment failed";
          this.text1 = this.$t(msgKey);
          this.snackbar = true;
          return;
        }

        if (!pay.SaveID) {
          this.text1 =
            "Payment registration has been completed. The product could not be introduced to your user. Please contact the support team.";
          this.snackbar = true;
          return;
        }

        // 2) Müşteri ürünü
        this.loadingMessage = this.$t("Linking product to customer") + "…";

        this.MusteriUrun.MusteriID = this.musteriidurun;
        this.MusteriUrun.OdemeBilgi.ID = pay.SaveID;
        this.MusteriUrun.OdemeBilgi.OdemeTip = this.UrunKayit.OdemeTip;
        this.MusteriUrun.OdemeBilgi.OdemeOnay = true;
        this.MusteriUrun.OdemeBilgi.UlkeID = this.UrunKayit.UlkeID;

        if (this.MusteriUrun.PaketBilgi.PaketTip == 2) {
          // Kontörlü paket
          this.MusteriUrun.KontorAdet = this.kontorAdet;
          this.MusteriUrun.KalanKontorAdet = this.kontorAdet;
          this.MusteriUrun.BaslangicTarih = getDateNow();
          this.MusteriUrun.BitisTarihi = getDateNow();
        } else {
          // Süreli/diğer paketler
          this.MusteriUrun.KontorAdet = 0;
          this.MusteriUrun.KalanKontorAdet = 0;
          this.MusteriUrun.BaslangicTarih = null;
          this.MusteriUrun.BitisTarihi = null;
        }

        const saveCustomerUrl = auth.API_URL + "api/Register/PackageCustomerSave";
        const custResp = await axios.post(saveCustomerUrl, this.MusteriUrun, { headers });
        const cust = custResp && custResp.data ? custResp.data : null;

        const msgKey2 = cust && cust.ResponseMessage ? cust.ResponseMessage : "Saved";
        this.text1 = this.$t(msgKey2);
        this.snackbar = true;

        if (cust && cust.Status === true) {
          // Başarılı tamamlandı
          localStorage.removeItem("po");
          setTimeout(() => {
            const url = "#/anasirket";
            window.open(url, "_self");
          }, 4000);
        }
      } catch (err) {
        // Hata mesajını güvenli çıkar
        let serverMsg = null;
        if (err && err.response && err.response.data) {
          serverMsg =
            (err.response.data.ResponseMessage ? err.response.data.ResponseMessage : null) ||
            (err.response.data.message ? err.response.data.message : null);
        }
        if (!serverMsg && err && err.message) {
          serverMsg = err.message;
        }

        let urlStr = err && err.config && err.config.url ? err.config.url : "";
        let tag = "Unknown";
        if (urlStr.indexOf("PackageCustomerSave") > -1) tag = "PackageCustomerSave";
        else if (urlStr.indexOf("PackageCustomerPaymentSave") > -1) tag = "PackageCustomerPaymentSave";

        this.text1 = "Service Unavailable-" + tag + (serverMsg ? " - " + serverMsg : "");
        this.snackbar = true;
      } finally {
        this.loadingMessage = "";
        this.loadingdialog = false;
      }
    },
  },
};

// Yardımcılar
function getDateNow() {
  // YYYY-MM-DD
  return new Date().toISOString().slice(0, 10);
}

function safeGetPo() {
  try {
    const raw = window.localStorage.getItem("po");
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}
</script>